function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 5c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 3.5c.245 0 .45.177.492.41l.008.09v2.5H14c.245 0 .45.177.492.41l.008.09c0 .245-.177.45-.41.492L14 13.5h-2c-.245 0-.45-.177-.492-.41L11.5 13v-3c0-.276.224-.5.5-.5zM7.404 3.706c.145.198.122.468-.042.639l-.068.06-2.75 2c-.223.162-.536.112-.698-.11-.145-.2-.122-.469.042-.64l.068-.06 2.75-2c.223-.162.536-.112.698.11zm9.813-.157l.077.047 2.75 2c.223.162.273.475.11.698-.144.199-.407.26-.62.157l-.078-.047-2.75-2c-.223-.162-.273-.475-.11-.698.144-.199.407-.26.62-.157z"
});

var SvgIconTimer = function SvgIconTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-timer.31312b14.svg";
export { ForwardRef as ReactComponent };